export enum CompaniesRoutingEnum {
  List = 'list',
  Detail = ':id',
}
